import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import AddRing from "./AddRing";
import RingCard from "./RingCard";
import { fixNumbers } from "../../../../utils";

// import Others files
const Ring = (props) => {
  let windowWidth = window.screen.width;

  const [openAddRingModal, setOpenAddRingModal] = useState(false);
  const handleModal = () => {
    setOpenAddRingModal((before) => !before);
  };

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });

  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
    {
      type: "textField",
      label_fa: "اسم",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 8,
    count: 0,
  });
  const [ringsList, setRingsList] = useState({ results: [] });
  const getRingsApi = useFetch({
    method: "get",
    url: "Bangle_Service",
    pagination: paginationPageInfo,
    params: {
      code: fixNumbers(codeFilter),
      brand: brandFilter,
      name: nameFilter,
    },
    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);
  };
  const filter = () => {
    getRingsApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter(null);
    setPaginationPageInfo({
      current: 1,
      pageSize: 1,
      count: 0,
    });
    getRingsApi.reFetch();
  };
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    getRingsApi.reFetch();
  };
  console.log("amin" , paginationPageInfo);
  return (
    <>
      <PanelTemplate sidebarActiveLink="rings">
        <>
          <div className="panel-main-header">
            <span>مدیریت النگو‌ها</span>
          </div>
          <div className="add-item-container">
            <span className="text">
              برای اضافه کردن النگوی جدید روی دکمه افزودن کلیک کنید.
            </span>
            <MuiButton
              onClick={handleModal}
              variant="outlined"
              icon={<AddIcon />}
              color="secondary"
              text="افزودن"
            />
          </div>
          {openAddRingModal && (
            <AddRing
              openModal={openAddRingModal}
              setOpenModal={setOpenAddRingModal}
              getRingsApi={getRingsApi}
            />
          )}
          <PanelFilter
            header="فیلتر النگوها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="grid md:grid-cols-4 md:gap-x-6 gap-y-4 md:gap-y-6">
            {ringsList.results.map((item, index) => {
              return [
                <>
                  <RingCard item={item} getRingsApi={getRingsApi} />
                </>,
              ];
            })}
          </div>
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
            page={paginationPageInfo.current}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default Ring;
